module.exports = __webpack_public_path__ + "static/img/6tgimg.ac3d2a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/6tgimg.jpg
// module id = MHN8
// module chunks = 2